export default __webpack_public_path__ + "static/media/alba-history-2025.666164b2.jpg";